import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Text, Img, Heading } from "components";

const NavbarAdmin = () => {
  const [menuOpen, setMenuOpen] = useState(true);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <header className="flex sm:flex-col justify-between items-center gap-5 px-[22px] py-[18px] sm:px-5 bg-black-900">
      {/* Toggle Button */}
      <button onClick={toggleMenu} aria-label="Toggle Menu">
        <Img src="images/img_megaphone.svg" alt="Megaphone Icon" className="h-[28px] md:w-full" />
      </button>

      {/* Navigation Links */}
      <nav className={`flex ${menuOpen ? "flex-wrap" : "hidden"} gap-[50px] md:gap-4`}>
        <ul className="flex gap-[50px] sm:flex-col">
          <li>
            <Link to="/home" className="cursor-pointer">
              <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
                Home
              </Heading>
            </Link>
          </li>
          <li>
            <Link to="/about" className="cursor-pointer">
              <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
                About
              </Heading>
            </Link>
          </li>
          <li>
            <Link to="/portfolios" className="cursor-pointer">
              <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
                Portfolios
              </Heading>
            </Link>
          </li>
          <li>
            <Link to="/account" className="cursor-pointer">
              <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
                Account
              </Heading>
            </Link>
          </li>
          <li>
            <button
              onClick={() => alert("Logged out successfully!")}
              className="cursor-pointer"
            >
              <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
                Logout
              </Heading>
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default NavbarAdmin;
